import { createSlice } from "@reduxjs/toolkit";

// const CSV = "CSV";
// const QUERY = "Query";
// const listTypes = [CSV, QUERY];

const initialState = {
  batchName: null,
  batchId: null,
  scheduledTime: null,
  selectedTimeType: null,
  uniqueVariables: null,
  status: null,
  recurringSchedule: null,
  type: null,
  emailTemplateId: null,
  emailTemplateVariables: [],
  emailTemplateVersionId: null,
  emailTemplateHTML: null,
  emailSender: "noreply@tomocredit.com",
  pushContent: null,
  pushContentHeader: null,
  pushContentVariables: [],
  pushContentData: {},
  textContent: null,
  textContentVariables: [],
  missingColumns: [],
  fileName: null,
  communicationTypes: {
    email: false,
    text: false,
    push: false,
  },
  columnNames:[],
  fileSamples: [],
  html:[],
};

const communicationBatching = createSlice({
  name: "communicationBatching",
  initialState,
  reducers: {
    addBatchName(state, action) {
      return {
        ...state,
        batchName: action.payload,
      };
    },
    addBatchId(state, action) {
      return {
        ...state,
        batchId: action.payload,
      };
    },
    addTextContent(state, action) {
      return {
        ...state,
        textContent: action.payload,
      };
    },
    addTextContentVariables(state, action) {
      return {
        ...state,
        textContentVariables: action.payload,
      };
    },
    addPushContent(state, action) {
      return {
        ...state,
        pushContent: action.payload,
      };
    },
    addPushContentHeader(state, action) {
      return {
        ...state,
        pushContentHeader: action.payload,
      };
    },
    addPushContentVariables(state, action) {
      return {
        ...state,
        pushContentVariables: action.payload,
      };
    },
    updateCommunicationTypes(state, action) {
      return {
        ...state,
        communicationTypes: action.payload,
      };
    },
    addEmail(state, action) {
      return {
        ...state,
        email: action.payload,
      };
    },
    addFileName(state, action) {
      return {
        ...state,
        fileName: action.payload,
      };
    },
    updateStatus(state, action) {
      return {
        ...state,
        status: action.payload,
      };
    },
    updateScheduledTime(state, action) {
      return {
        ...state,
        scheduledTime: action.payload,
      };
    },
    updateSelectedTimeType(state, action) {
      return {
        ...state,
        selectedTimeType: action.payload,
      };
    },
    clearBatch() {
      return initialState;
    },
    addEmailTemplateId(state, action) {
      return {
        ...state,
        emailTemplateId: action.payload,
      };
    },
    addEmailTemplateVariables(state, action) {
      return {
        ...state,
        emailTemplateVariables: action.payload,
      };
    },
    addEmailTemplateVersionId(state, action) {
      return {
        ...state,
        emailTemplateVersionId: action.payload,
      };
    },
    addEmailTemplateHTML(state, action) {
      return {
        ...state,
        emailTemplateHTML: action.payload,
      };
    },
    addEmailSender(state, action) {
      return {
        ...state,
        emailSender: action.payload,
      };
    },
    addMissingColumns(state, action) {
      return {
        ...state,
        missingColumns: action.payload,
      };
    },
    addFileSamples(state, action) {
      return {
        ...state,
        fileSamples: action.payload,
      };
    },
    addPushContentData(state, action) {
      return {
        ...state,
        pushContentData: action.payload,
      };
    },
    addHTML(state, action) {
      return {
        ...state,
        html: action.payload,
      };
    },
    addColumnNames(state, action) {
      return {
        ...state,
        columnNames: action.payload,
      };
    },
    updateRecurringSchedule(state, action) {
      return {
        ...state,
        recurringSchedule: action.payload,
      };
    },
  },
});

export const {
  addBatchId,
  addBatchName,
  addEmail,
  addEmailTemplateId,
  addEmailTemplateVariables,
  addFileName,
  addPushContent,
  addPushContentHeader,
  addPushContentVariables,
  addPushContentData,
  addTextContent,
  addTextContentVariables,
  updateStatus,
  updateCommunicationTypes,
  updateScheduledTime,
  updateRecurringSchedule,
  clearBatch,
  updateSelectedTimeType,
  addEmailTemplateVersionId,
  addEmailTemplateHTML,
  addMissingColumns,
  addFileSamples,
  addHTML,
  addEmailSender,
  addColumnNames,
} = communicationBatching.actions;
export default communicationBatching.reducer;
